// METIS Hub wording — namespace "login" (ko), 82 keys.
// Extracted once from the approved mockup (poc-plan/mockup-src: js/screens/login.js App.addI18n).
// From now on this file is the source: edit it by hand (keep ko/en keys in pairs — packages/i18n tests check
// key parity, Hangul in English text and the plan 9.1.3 wording rules). Placeholders: {name}, plural {n|one|other}.
const login: Record<string, string> = {
  "login.title": "로그인",
  "login.sub": "AI 사용 기록을 보려면 로그인하세요",
  "login.id": "아이디",
  "login.idPh": "name@example.com",
  "login.pw": "비밀번호",
  "login.pwPh": "비밀번호 입력",
  "login.pwShow": "비밀번호 보기",
  "login.pwHide": "비밀번호 숨기기",
  "login.caps": "Caps Lock이 켜져 있어요",
  "login.submit": "로그인",
  "login.busy": "로그인 중…",
  "login.or": "또는",
  "login.google": "Google로 계속하기",
  "login.googleBusy": "Google 계정을 확인하는 중…",
  "login.googleHint": "회사 도메인(example.com) 계정만 쓸 수 있어요.",
  "login.googleOff": "Google 로그인이 아직 설정되지 않았어요. 관리자에게 문의하세요.",
  "login.noAccount": "계정이 없으면 관리자에게 초대를 요청하세요.",
  "login.forgot": "비밀번호를 잊었다면 관리자에게 재설정을 요청하세요.",
  "login.err.id": "아이디를 입력하세요.",
  "login.err.pw": "비밀번호를 입력하세요.",
  "login.err.wrong": "아이디 또는 비밀번호가 맞지 않아요 · 남은 시도 {n}번",
  "login.err.lastHint": "한 번 더 틀리면 {min}분 동안 잠겨요.",
  "login.err.server": "지금은 로그인할 수 없어요. 잠시 뒤 다시 시도하세요.",
  "login.err.serverCode": "오류 번호 AUTH-503 · 로그인 서버가 응답하지 않아요",
  "login.gerr.domain": "회사 도메인(example.com) 계정이 아니라서 로그인할 수 없어요. 회사 Google 계정으로 다시 시도하세요.",
  "login.gerr.cancel": "Google 로그인을 마치지 않았어요. 다시 시도하세요.",
  "login.gerr.unlinked": "이 Google 계정은 다른 사용자에게 연결되어 있어요. 관리자에게 문의하세요.",
  "login.gerr.other": "Google 로그인에 실패했어요. 잠시 뒤 다시 시도하세요.",
  "login.welcome": "{name} 님, 어서 오세요",
  "login.lock.title": "로그인을 잠시 잠갔어요",
  "login.lock.desc": "비밀번호를 {n}번 틀려 {min}분 동안 로그인할 수 없어요. 내가 시도한 게 아니라면 관리자에게 알려 주세요.",
  "login.lock.left": "{mmss} 뒤에 다시 시도할 수 있어요",
  "login.lock.leftMin": "남은 시간 {n}분",
  "login.lock.ended": "잠금이 풀렸어요. 다시 로그인하세요.",
  "login.mfa.kicker": "다단계 인증(MFA)",
  "login.mfa.title": "인증 번호를 넣어 주세요",
  "login.mfa.desc": "{name} 님 계정은 관리 권한이 있어 다단계 인증을 거쳐요. 인증 앱에 보이는 6자리 번호를 입력하세요.",
  "login.mfa.code": "인증 번호 6자리",
  "login.mfa.hint": "번호는 30초마다 바뀌어요.",
  "login.mfa.submit": "확인",
  "login.mfa.err": "6자리 숫자를 입력하세요.",
  "login.mfa.other": "다른 계정으로 로그인",
  "login.mfa.help": "인증 앱을 쓸 수 없으면 관리자에게 재설정을 요청하세요.",
  "login.gate.kicker": "처음 로그인 · {i}/{n}단계",
  "login.gate.stepsLabel": "처음 로그인 단계",
  "login.gate.s.password": "비밀번호 바꾸기",
  "login.gate.s.pledge": "금지 용도 약정",
  "login.gate.s.mfaSetup": "다단계 인증 등록",
  "login.gate.noClose": "처음 로그인 단계는 건너뛸 수 없어요. 모두 마치면 홈으로 가요.",
  "login.gate.password.title": "비밀번호를 바꿔 주세요",
  "login.gate.password.desc": "관리자가 준 임시 비밀번호로 로그인했어요. 계속하려면 새 비밀번호를 정하세요.",
  "login.gate.pw.new": "새 비밀번호",
  "login.gate.pw.confirm": "새 비밀번호 확인",
  "login.gate.pw.rule.len": "10자 이상",
  "login.gate.pw.rule.mix": "영문 대문자·소문자·숫자·특수문자 가운데 3가지 이상",
  "login.gate.pw.rule.id": "아이디가 들어가지 않음",
  "login.gate.pw.rule.match": "두 칸이 같음",
  "login.gate.pw.ruleOk": "맞음",
  "login.gate.pw.ruleNo": "아직",
  "login.gate.pw.rules": "비밀번호 조건",
  "login.gate.pw.submit": "비밀번호 바꾸기",
  "login.gate.pw.err": "조건을 모두 맞춰 주세요.",
  "login.gate.pw.done": "비밀번호를 바꿨어요. 다른 곳의 로그인은 모두 끝났어요.",
  "login.gate.pledge.title": "금지 용도 약정",
  "login.gate.pledge.desc": "{role} 역할은 남의 질문·답변 글이나 실명을 볼 수 있어요. 시작하기 전에 금지된 용도로 쓰지 않겠다고 약정해 주세요.",
  "login.gate.pledge.1": "인사 평가·근태·성과 판단에 쓰지 않아요.",
  "login.gate.pledge.2": "보안 사고 조사·사용자 지원·장애 조사 같은 업무 목적 밖에서 글을 열지 않아요.",
  "login.gate.pledge.3": "본 내용을 허락 없이 옮기거나 내보내지 않아요.",
  "login.gate.pledge.4": "열 때마다 사유를 남기고, 당사자에게 열람이 표시된다는 것을 알아요.",
  "login.gate.pledge.check": "위 내용을 읽었고 지키겠다고 약정해요",
  "login.gate.pledge.sign": "서명 — 이름을 그대로 입력하세요({name})",
  "login.gate.pledge.version": "약정문 v1.0 · 역할이 바뀌거나 약정문이 바뀌면 다시 약정해요 · 약정은 열람·변경 이력에 남아요",
  "login.gate.pledge.submit": "약정하고 계속하기",
  "login.gate.pledge.errCheck": "약정에 체크해 주세요.",
  "login.gate.pledge.errSign": "계정 이름과 같게 입력하세요.",
  "login.gate.pledge.done": "약정을 남겼어요.",
  "login.gate.mfaSetup.title": "다단계 인증(MFA)을 등록하세요",
  "login.gate.mfaSetup.desc": "{role} 역할은 관리 권한이 있어 다단계 인증이 꼭 필요해요. 인증 앱으로 아래 QR코드를 읽고, 앱에 나온 6자리 번호를 입력하세요.",
  "login.gate.mfa.key": "설정 키(목업 예시 값)",
  "login.gate.mfa.copy": "설정 키 복사",
  "login.gate.mfa.submit": "등록하고 시작하기",
  "login.gate.mfa.done": "다단계 인증을 등록했어요.",
};

export default login;
